import { useRef } from "react";
import { IMG } from "../data/images";
import { VIDEO } from "../data/video";
import { useScrollVideo, range } from "../hooks/useScrollVideo";
import { useLang } from "../i18n";

// Hauteur de la piste de scroll, en hauteurs d'écran.
const SCROLL_VH = 280;

export const Preparacion = () => {
  const { t } = useLang();
  const introRef = useRef(null);
  const outroRef = useRef(null);

  const { sectionRef, videoRef } = useScrollVideo((p) => {
    // Le chapeau tient le premier tiers, puis laisse la place à la conclusion.
    if (introRef.current) {
      const a = range(p, 0.02, 0.16) * (1 - range(p, 0.42, 0.56));
      introRef.current.style.opacity = a;
      introRef.current.style.transform = `translateY(${(1 - a) * 26}px)`;
    }
    if (outroRef.current) {
      const b = range(p, 0.62, 0.78) * (1 - range(p, 0.94, 1));
      outroRef.current.style.opacity = b;
      outroRef.current.style.transform = `translateY(${(1 - b) * 26}px)`;
    }
  });

  return (
    <section
      id="preparacion"
      ref={sectionRef}
      data-testid="preparacion-section"
      style={{ height: `${SCROLL_VH}vh` }}
      className="scroll-video-section relative bg-[#2B1E16]"
    >
      <div data-scroll-video-stage className="scroll-video-stage sticky top-0 h-[100svh] w-full overflow-hidden">
        <video
          ref={videoRef}
          poster={IMG.crepe}
          muted
          playsInline
          preload="metadata"
          disablePictureInPicture
          aria-hidden="true"
          tabIndex={-1}
          className="scroll-video-media absolute inset-0 h-full w-full object-cover"
        >
          <source media="(max-width: 767px)" src={VIDEO.preparacionMobile} type="video/mp4" />
          <source src={VIDEO.preparacion} type="video/mp4" />
        </video>

        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#2B1E16] via-[#2B1E16]/35 to-[#2B1E16]/70" />
        <div className="grain pointer-events-none absolute inset-0" />

        <div className="scroll-video-copy relative z-10 flex h-full w-full flex-col items-center justify-center px-6 text-center md:px-12">
          <div ref={introRef} style={{ opacity: 0 }} className="absolute max-w-[26ch]">
            <p className="label text-[#D9B98A]">{t.preparacion.label}</p>
            <h2 className="mt-6 font-serif text-4xl font-light leading-[1.06] text-[#F5EDE3] sm:text-5xl lg:text-6xl">
              {t.preparacion.title1}
            </h2>
          </div>

          <div ref={outroRef} style={{ opacity: 0 }} className="absolute max-w-[34ch]">
            <h2 className="font-serif text-4xl font-light leading-[1.06] text-[#F5EDE3] sm:text-5xl lg:text-6xl">
              {t.preparacion.title2}
            </h2>
            <p className="mt-7 font-sans text-sm font-light leading-relaxed text-[#F5EDE3]/70 md:text-base">
              {t.preparacion.text}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
